export default __webpack_public_path__ + "static/media/fleet-banner.1b762eaf.webp";